<script setup lang="ts">
import TemperatureSensorVehicleAutoComplete from '@/components/TemperatureSensorChartParts/VehicleAutoComplete.vue';
import DepartmentAutoComplete from "@/components/AutoCompletes/DepartmentAutoComplete.vue";
import getDepartment from "@/types/responses/getDepartment";
import getVehicle from "@/types/responses/getVehicle";
import { reactive, computed } from 'vue';
import i18n from '@/lang/i18n';

const emits = defineEmits(['search']);
const props = defineProps<{
  loading: boolean,
  windowInnerWidth: number,
  isDepartment: boolean
}>()

const form = reactive({
  department: undefined as getDepartment | undefined,
  vehicle: undefined as getVehicle | undefined,
})

const changeSearchButton = computed(() => {
  return props.loading ? i18n.global.t('pages.common.button.loading') : i18n.global.t('pages.common.button.exec');
})

function handleClickSearch() {
  emits('search', form);
}

function clearForm() {
  form.department = undefined;
  form.vehicle = undefined;
}

</script>
<template>
  <div class="select-office mb-6 col-12">
    <v-row class="d-flex">
      <v-col :cols="windowInnerWidth > 800 ? 4 : 8">
        <DepartmentAutoComplete
          v-model="form.department"
          :isUnaffiliated="!props.isDepartment"
          :selectFirstIfOnlyOne="props.isDepartment"
        />
      </v-col>
      <v-col :cols="windowInnerWidth > 800 ? 4 : 8">
        <TemperatureSensorVehicleAutoComplete
          v-model="form.vehicle"
        />
      </v-col>
      <v-col class="d-flex align-end" :cols="windowInnerWidth > 800 ? 2 : 4">
        <v-btn
          class="ma-2 exec-btn"
          @click="handleClickSearch"
          :style="{
            backgroundColor: props.loading ? '#B3B8BB' : '',
          }"
        >
          {{ changeSearchButton }}
        </v-btn>
        <v-btn
          class="ma-2 reset-btn"
          @click="clearForm"
        >
          {{ i18n.global.t('pages.common.button.reset') }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>